import { useMemo } from 'react';
import { DateTime } from 'luxon';
import type {
  SimpleChartData,
  SimpleChartDataset
} from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';

export default function useChartFillDatasetsDates(
  data: SimpleChartData[] | undefined,
  datasets: SimpleChartDataset[],
  days: number | string = 30,
  fillValue: number | null = 0
): SimpleChartData[] | undefined {
  return useMemo(() => {
    if (!data || data.length === 0) {
      return data;
    }

    const normalizedDays = typeof days === 'string' ? Number(days) : days;

    const xField = datasets[0].xField;
    const today = DateTime.utc().startOf('day');
    const dt = today.minus({
      days: normalizedDays > 365 ? 365 : normalizedDays
    });
    const earliestDate = DateTime.min(
      DateTime.fromISO(String(data[0][xField])),
      dt
    );

    const newData: SimpleChartData[] = [];
    let currentDay = earliestDate;
    let i = 0;

    while (currentDay <= today) {
      const currentIso = currentDay.toISO();
      let matched = false;

      while (i < data.length) {
        const itemDate = DateTime.fromISO(String(data[i][xField]));
        if (itemDate.equals(currentDay)) {
          const obj: SimpleChartData = { [xField]: currentIso };
          datasets.forEach((ds) => {
            obj[ds.yField] = data[i][ds.yField];
          });
          newData.push(obj);
          i++;
          matched = true;
          break;
        } else {
          break;
        }
      }

      if (!matched) {
        const obj: SimpleChartData = { [xField]: currentIso };
        datasets.forEach((ds) => {
          obj[ds.yField] = fillValue;
        });
        newData.push(obj);
      }

      currentDay = currentDay.plus({ days: 1 });
    }

    return newData;
  }, [data, datasets, fillValue, days]);
}
